import React, { Component } from 'react';
import {
  TreeDataState,
  CustomTreeData,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableTreeColumn,
  TableColumnVisibility,
  Toolbar,
  ColumnChooser,
  SearchPanel,
  VirtualTable,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import Paper from '@material-ui/core/Paper';
import {
  ArgumentAxis,
  ValueAxis,
  Chart,
  LineSeries,
  SplineSeries,
  Tooltip
} from '@devexpress/dx-react-chart-material-ui';
import { EventTracker } from '@devexpress/dx-react-chart';
import metaData from "../metaData";
import axios from 'axios';
import { CSVLink, CSVDownload } from "react-csv";
// import moment from 'moment';
import * as moment from 'moment';
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';
import _ from 'lodash';
import { _workOrder } from './selectWOrkOrder';
import loader from "../images/loader.gif"
let addDates = metaData[0].addDates;
let map;
let thinUrl='https://zip.pr/IN/';

let popup = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
});

let allApis = localStorage.getItem("allApis");
if (allApis) {
  allApis = JSON.parse(allApis);
}

let work_order;
let latest_work_order;
let workOrder;
let workorder_param;
// let homeUlbDataParams;
// let agentSummeryParams;
let homeUlbDataParams = metaData[0].agency_data.params;
let agentSummeryParams = metaData[0].agent_summary.params;

const generateData = (start, end, step) => {
  const data = [];
  for (let i = start; i < end; i += step) {
    data.push({ splineValue: Math.sin(i) / i, lineValue: ((i / 15) ** 2.718) - 0.2, argument: i });
  }
  return data;
};

const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
let th;




export default class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      agencyDataObject: [],
      selectedProject: metaData[0],
      agentSummery: [],
      realtimeData: [{
        zippr: 'loading...',
        createdBy: '',
        daysAgo: ""
      }],
      data: generateData(2.5, 12, 0.5),
      work_order: work_order,
      realTimeActivityData: "",
      ulbNameArray: [],
      ulbLevel: "",
      WorkOrderClients: [],
      snapShotData: "",
      agentSummeryBeginingDay: "Today",
      agentSummeryLoading: false,
      ulbReportLoading: false,
      zoomTo: "",
      agentSummeryHeader: [],
      agentSummeryData: [],
      clickeddownloadAgencyDta: false,
      agentSummeryAllCsv:[],
      clickeddownloadUlbData:false,
      ulbAllCsv:[],
      headers : [
        { label: "Agency Name", key: "agencyName" },
        { label: "Attendance", key: "attendance" },
        { label: "Today", key: "today" },
        { label: "Total", key: "total" }
      ],
      ulbHeader: [
        { label: "Buildings", key: "buildings" },
        { label: "Portions", key: "portions" },
        { label: "Ulb", key: "ulb" }
      ]

    }
    this.updateData = this.updateData.bind(this);
    this.agentSummeryFilteredDataCall = this.agentSummeryFilteredDataCall.bind(this);
    this.callDidMountMultipleTimes = this.callDidMountMultipleTimes.bind(this);
    this.callSnapShotData = this.callSnapShotData.bind(this);
    this.callRealTimeData = this.callRealTimeData.bind(this);
    this.refreshClick = this.refreshClick.bind(this);
    this.callMap = this.callMap.bind(this);
    this.downloadAgentSummeryData = this.downloadAgentSummeryData.bind(this);
    this.clickAgentSummeryAllcsv=this.clickAgentSummeryAllcsv.bind(this);
    this.downloadUlbData=this.downloadUlbData.bind(this);
    this.toggleUlbDownloadOptions=this.toggleUlbDownloadOptions.bind(this);
    // this.timer=this.timer.bind(this);

    th = this;
  }

  componentWillUnmount() {

    clearInterval(this.timer);
    this.timer = null;

    //   let allApis = localStorage.getItem("allApis");
    //   if(allApis){
    //     alert('unmo')
    //   allApis = JSON.parse(allApis);
    //   this.setState({
    //     selectedProject:allApis
    //   })
    // }
    //   let allApis = localStorage.getItem("allApis");
    //   if(allApis){
    //     alert('unmo')
    //   allApis = JSON.parse(allApis);
    //   this.setState({
    //     selectedProject:allApis
    //   })
    // }
  }

  componentWillMount() {
    let allApis = localStorage.getItem("allApis");
    if (allApis) {
      allApis = JSON.parse(allApis);
    }
    workOrder = localStorage.getItem("workOrderObj");
    workOrder = JSON.parse(workOrder)
    if (workOrder) {
      work_order = workOrder.workOrder;
      allApis.agency_data.params.spaceKey = workOrder.hierarchy[workOrder.ulbLevel];

    }
    // allApis.agency_data.params.spaceKey=metaData[0].agency_data.params.spaceKey
    homeUlbDataParams = allApis.agency_data.params;
    agentSummeryParams = allApis.agent_summary.params;

  }

  componentDidMount() {
    this.callMap();

    console.log(this.state.selectedProject.layer_1.params, "his.state.selectedProject.layer_1.params")
    axios.get(this.state.selectedProject.layer_1.url, {
      params: this.state.selectedProject.layer_1.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        console.log(res, "res")
        let zoomTo;
        let zoomToArr;
        if (res.data.ok) {
          console.log(res.data.response.StaticClusters, "resresres");
          let response = res.data.response.StaticClusters;

          if (response.length) {
            zoomToArr = response[0].geometry.coordinates;

            console.log(response[0], "responseresponse")

            if (zoomToArr.length) {
              let co_ordinates;
              if (zoomToArr[0].length) {
                zoomTo = zoomToArr[0][0];
                if (zoomTo.length == 2) {

                  if (zoomToArr.length > 4) {
                    var polygon = turf.polygon(zoomToArr);
                    var center = turf.centerOfMass(polygon);
                    co_ordinates = center.geometry.coordinates;
                    console.log(co_ordinates, "co_ordinatesco_ordinates2");
                  }

                  zoomTo = zoomTo
                } else if (zoomTo.length > 2) {
                  console.log(zoomToArr[0], "zoomTo[0]");
                  if (zoomToArr[0].length > 4) {
                    var polygon = turf.polygon(zoomToArr);
                    var center = turf.centerOfMass(polygon);
                    co_ordinates = center.geometry.coordinates;
                    console.log(co_ordinates, "co_ordinatesco_ordinates2");
                  }

                  zoomTo = co_ordinates
                }
                map.flyTo({
                  center: zoomTo,
                  zoom: 5
                });
                localStorage.setItem("initialZoom", JSON.stringify(zoomTo));
                this.setState({
                  zoomTo: zoomTo
                })
              }
            }

          }
          console.log(zoomTo, "zoomTozoomTo")
        }
      })

    // let zoomCoredenate;
    // axios.get(this.state.selectedProject.hourlyZipprs.url, {     //noneed in second time
    //   params: this.state.selectedProject.hourlyZipprs.params,
    //   headers: this.state.selectedProject.headers
    // }).then(res => {
    //   if (res.data) {
    //     if (res.data.response) {
    //       let response = res.data.response.zipprObjs;
    //       let source = {};
    //       source.features = [];
    //       source.type = "FeatureCollection";
    //       source.crs = { type: "name", properties: { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } };
    //       let features = [];
    //       if (response[0]) {
    //         zoomCoredenate = response[0].location ? response[0].location.coordinates : [];
    //       } else {
    //         zoomCoredenate = [];
    //       }
    //       response.map(ele => {
    //         let obj = {};
    //         obj.geometry = {};
    //         obj.geometry.type = 'Point';
    //         obj.geometry.coordinates = ele.location ? ele.location.coordinates : [];
    //         obj.type = "Feature";
    //         obj.properties = { zippr: ele.zippr, id: ele.zippr }
    //         features.push(obj);
    //       })
    //       source.features = features;

    //       if (source.features.length) {
    //         //map.setStyle('mapbox://styles/mapbox/streets-v11');

    //         // map.on('style.load', () => {
    //         //   const waiting = () => {
    //         //     if (!map.isStyleLoaded()) {
    //         //       setTimeout(waiting, 200);
    //         //     } else {
    //         //       loadMyLayers();
    //         //     }
    //         //   };
    //         //   waiting();
    //         // });


    //         // setTimeout(()=>{


    //         // map.on('idle',function(){

    //         //   if (map.getLayer('hourly-zipprs')) {
    //         //     // map.removeSource('ddnsearch-polygonSource');
    //         //     map.removeLayer('hourly-zipprs');
    //         //   };
    //         //   if (map.getSource('hourlyZipprs')) {
    //         //     map.removeSource('hourlyZipprs');
    //         //   }
    //         if (map) {
    //           // map.addSource('hourlyZipprs', {
    //           //   "type": "geojson",
    //           //   "data": source
    //           // })
    //           // map.addLayer({
    //           //   "id": "hourly-zipprs",
    //           //   "source": "hourlyZipprs",
    //           //   "type": "circle",
    //           //   "paint": {
    //           //     "circle-radius": 3.5,
    //           //     "circle-opacity": 0.8,
    //           //     "circle-stroke-width": 1,
    //           //     "circle-stroke-color": "#ff7800",
    //           //     "circle-stroke-opacity": 1,
    //           //     'circle-color': '#ff7800'
    //           //   },
    //           // });
    //           map.on('load', function () {
    //             map.addSource('hourlyZipprs', {
    //               "type": "geojson",
    //               "data": source,
    //               cluster: true,
    //               clusterMaxZoom: 14,
    //               clusterRadius: 50
    //             })
    //             map.addLayer({
    //               "id": "hourly-zipprs",
    //               "source": "hourlyZipprs",
    //               "type": "circle",
    //               "filter": ['has', 'point_count'],
    //               paint: {
    //                 'circle-color': [
    //                   'step',
    //                   ['get', 'point_count'],
    //                   '#51bbd6',
    //                   100,
    //                   '#f1f075',
    //                   750,
    //                   '#f28cb1'
    //                 ],
    //                 'circle-radius': [
    //                   'step',
    //                   ['get', 'point_count'],
    //                   20,
    //                   100,
    //                   30,
    //                   750,
    //                   40
    //                 ]
    //               }
    //             });

    //             map.addLayer({
    //               id: 'cluster-count',
    //               type: 'symbol',
    //               source: 'hourlyZipprs',
    //               filter: ['has', 'point_count'],
    //               layout: {
    //                 'text-field': '{point_count_abbreviated}',
    //                 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    //                 'text-size': 12
    //               }
    //             });

    //             map.addLayer({
    //               id: 'unclustered-point',
    //               type: 'circle',
    //               source: 'hourlyZipprs',
    //               filter: ['!', ['has', 'point_count']],
    //               paint: {
    //                 'circle-color': '#ff7800',
    //                 'circle-radius': 4,
    //                 'circle-stroke-width': 1,
    //                 'circle-stroke-color': '#fff'
    //               }
    //             });

    //             map.on('click', 'hourly-zipprs', function (e) {
    //               var features = map.queryRenderedFeatures(e.point, {
    //                 layers: ['hourly-zipprs']
    //               });
    //               var clusterId = features[0].properties.cluster_id;
    //               map.getSource('hourlyZipprs').getClusterExpansionZoom(
    //                 clusterId,
    //                 function (err, zoom) {
    //                   if (err) return;

    //                   map.easeTo({
    //                     center: features[0].geometry.coordinates,
    //                     zoom: zoom
    //                   });
    //                 }
    //               );
    //             })


    //             if (zoomCoredenate.length) {
    //               map.flyTo({
    //                 center: zoomCoredenate,
    //                 zoom: 8
    //               });
    //             }

    //             map.on('mousemove', 'unclustered-point', function (e) {

    //               var coordinates = e.features[0].geometry.coordinates.slice();
    //               var mag = e.features[0].properties.zippr;
    //               var tsunami;

    //               if (e.features[0].properties.tsunami === 1) {
    //                 tsunami = 'yes'
    //               } else {
    //                 tsunami = 'no'
    //               }

    //               // Ensure that if the map is zoomed out such that
    //               // multiple copies of the feature are visible, the
    //               // popup appears over the copy being pointed to.
    //               while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
    //                 coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    //               }

    //               // new mapboxgl.Popup()
    //               popup
    //                 .setLngLat(coordinates)
    //                 .setHTML("<b>" + mag + "</b>")
    //                 .addTo(map);
    //             });

    //             // map.on('mousemove', 'hourly-zipprs', function (e) {
    //             //   var description = e.features[0].properties.description;
    //             //   var coordinates = e.features[0].geometry.coordinates.slice();
    //             //   popup
    //             //     .setLngLat(e.lngLat)
    //             //     .setHTML("<b>" + e.features[0].properties.cluster_id + "</b>"
    //             //     )
    //             //     .addTo(map);
    //             // });
    //             map.on('mouseleave', 'unclustered-point', function () {
    //               popup.remove()
    //             });

    //             // },1000);

    //           })
    //         }
    //       }
    //     }
    //   }
    // })


    // mapboxgl.accessToken = 'pk.eyJ1IjoidmVudWdvcGFhbCIsImEiOiJjazNmZml1bmYwM3FpM25vemh3cnlmOXR0In0.AdnqIyCvzVQYas34CcDwvg';
    // map = new mapboxgl.Map({
    //   container: 'map',
    //   style:
    //     //{
    //     //   'version': 8,
    //     //   'sources': {
    //     //   'raster-tiles': {
    //     //   'type': 'raster',
    //     //   'tiles': [
    //     //     'https://4.aerial.maps.api.here.com/maptile/2.1/maptile/newest/satellite.day/{z}/{x}/{y}/256/png?app_id=P4UEExcJ2GCOynv1KNIb&app_code=hFRd8KXFK-iMhbgwzqmDXA'
    //     // ],
    //     //   'tileSize': 256,
    //     //   'attribution':
    //     //   'Map tiles by <a target="_top" rel="noopener" href="http://stamen.com">Stamen Design</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
    //     //   }
    //     //   },
    //     //   'layers': [
    //     //   {
    //     //   'id': 'simple-tiles',
    //     //   'type': 'raster',
    //     //   'source': 'raster-tiles',
    //     //   'minzoom': 0,
    //     //   'maxzoom': 22
    //     //   }
    //     // ]},
    //     'mapbox://styles/mapbox/streets-v11',
    //   // 'mapbox://styles/mapbox/dark-v10',

    //   center: [79.7400, 15.907],
    //   zoom: 5.5,

    // });









    this.updateData(homeUlbDataParams, agentSummeryParams);
    if (this.state.selectedProject.agent_summary.params) {
      this.agentSummeryFilteredDataCall(this.state.selectedProject.agent_summary.params);
    }


    axios.get(this.state.selectedProject.workOrderClients.url, {     //noneed in second time
      params: this.state.selectedProject.workOrderClients.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let workOrderClientsData = res.data.response.clientObjs;
        let clientObjectAyyay = [];
        workOrderClientsData.map((client) => {
          let clientObject = {
            name: client.app_name,
            id: client._id
          }
          clientObjectAyyay.push(clientObject);
        })
        this.setState({
          WorkOrderClients: clientObjectAyyay
        })

      })


    axios.get(this.state.selectedProject.workOrder.url, {
      params: this.state.selectedProject.workOrder.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        if (res.data.response) {
          let hierarchy = res.data.response.workOrderObj.hierarchy;
          let ulbLevel = hierarchy[hierarchy.length - 2];
          this.setState({
            ulbLevel: ulbLevel
          })
        }
      })

    axios.get(this.state.selectedProject.ulb_treeDtata.url, {
      params: this.state.selectedProject.ulb_treeDtata.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let response = res.data.response.analyticsDocs;
        let dataArray = [];
        response.map((ele) => {
          let spaceKey = ele.space.key;
          if (spaceKey == this.state.ulbLevel) {
            let dataObj = {
              name: ele.space.name,
              spaceValue: ele.space.value
            }
            dataArray.push(dataObj)
          }
        })
        dataArray = _.uniqBy(dataArray, "name");
        this.setState({
          ulbNameArray: dataArray
        })
      })



    // axios.get(this.state.selectedProject.recentActivity.url, {
    //   params: this.state.selectedProject.recentActivity.params,
    //   headers: this.state.selectedProject.headers
    // })
    //   .then(res => {
    //     let response = res.data.response.recentActivityObjects;
    //     let dataObjArray = [];
    //     response.map((element) => {
    //       let dataObj = {};
    //       dataObj.zippr = element.zippr;
    //       dataObj.agentName = element.agentName;
    //       dataObj.createdAt = element.createdAt;
    //       dataObjArray.push(dataObj);
    //     });
    //     this.setState({
    //       realtimeData: dataObjArray
    //     })
    //   })

    // axios.get(this.state.selectedProject.snapShot.url, {
    //   params: this.state.selectedProject.snapShot.params,
    //   headers: this.state.selectedProject.headers
    // })
    //   .then(res => {
    //     this.setState({
    //       snapShotData: res.data.response.result
    //     })
    //   })

    this.callSnapShotData();
    this.callRealTimeData();

    this.callDidMountMultipleTimes();

    this.timer = setInterval(() => {
      th.callDidMountMultipleTimes();
    }, 60000)

  }




  callDidMountMultipleTimes() {

    this.agentSummeryFilteredDataCall(agentSummeryParams);
    this.updateData(homeUlbDataParams);
    this.callSnapShotData();
    this.callRealTimeData();

  }

  callMap() {

    let zoomCoredenate;
    axios.get(this.state.selectedProject.hourlyZipprs.url, {     //noneed in second time
      params: this.state.selectedProject.hourlyZipprs.params,
      headers: this.state.selectedProject.headers
    }).then(res => {
      if (res.data) {
        if (res.data.response) {
          let response = res.data.response.zipprObjs;
          let source = {};
          source.features = [];
          source.type = "FeatureCollection";
          source.crs = { type: "name", properties: { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } };
          let features = [];
          if (response[0]) {
            zoomCoredenate = response[0].location ? response[0].location.coordinates : [];
          } else {
            zoomCoredenate = [];
          }
          response.map(ele => {
            let obj = {};
            obj.geometry = {};
            obj.geometry.type = 'Point';
            obj.geometry.coordinates = ele.location ? ele.location.coordinates : [];
            obj.type = "Feature";
            obj.properties = { zippr: ele.zippr, id: ele.zippr }
            features.push(obj);
          })
          source.features = features;

          if (source.features.length) {
            //map.setStyle('mapbox://styles/mapbox/streets-v11');

            // map.on('style.load', () => {
            //   const waiting = () => {
            //     if (!map.isStyleLoaded()) {
            //       setTimeout(waiting, 200);
            //     } else {
            //       loadMyLayers();
            //     }
            //   };
            //   waiting();
            // });


            // setTimeout(()=>{


            // map.on('idle',function(){

            //   if (map.getLayer('hourly-zipprs')) {
            //     // map.removeSource('ddnsearch-polygonSource');
            //     map.removeLayer('hourly-zipprs');
            //   };
            //   if (map.getSource('hourlyZipprs')) {
            //     map.removeSource('hourlyZipprs');
            //   }
            if (map) {
              // map.addSource('hourlyZipprs', {
              //   "type": "geojson",
              //   "data": source
              // })
              // map.addLayer({
              //   "id": "hourly-zipprs",
              //   "source": "hourlyZipprs",
              //   "type": "circle",
              //   "paint": {
              //     "circle-radius": 3.5,
              //     "circle-opacity": 0.8,
              //     "circle-stroke-width": 1,
              //     "circle-stroke-color": "#ff7800",
              //     "circle-stroke-opacity": 1,
              //     'circle-color': '#ff7800'
              //   },
              // });
              map.on('load', function () {
                map.addSource('hourlyZipprs', {
                  "type": "geojson",
                  "data": source,
                  cluster: true,
                  clusterMaxZoom: 14,
                  clusterRadius: 50
                })
                map.addLayer({
                  "id": "hourly-zipprs",
                  "source": "hourlyZipprs",
                  "type": "circle",
                  "filter": ['has', 'point_count'],
                  paint: {
                    'circle-color': [
                      'step',
                      ['get', 'point_count'],
                      '#51bbd6',
                      100,
                      '#f1f075',
                      750,
                      '#f28cb1'
                    ],
                    'circle-radius': [
                      'step',
                      ['get', 'point_count'],
                      20,
                      100,
                      30,
                      750,
                      40
                    ]
                  }
                });

                map.addLayer({
                  id: 'cluster-count',
                  type: 'symbol',
                  source: 'hourlyZipprs',
                  filter: ['has', 'point_count'],
                  layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 12
                  }
                });

                map.addLayer({
                  id: 'unclustered-point',
                  type: 'circle',
                  source: 'hourlyZipprs',
                  filter: ['!', ['has', 'point_count']],
                  paint: {
                    'circle-color': '#ff7800',
                    'circle-radius': 4,
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#fff'
                  }
                });

                map.on('click', 'hourly-zipprs', function (e) {
                  var features = map.queryRenderedFeatures(e.point, {
                    layers: ['hourly-zipprs']
                  });
                  var clusterId = features[0].properties.cluster_id;
                  map.getSource('hourlyZipprs').getClusterExpansionZoom(
                    clusterId,
                    function (err, zoom) {
                      if (err) return;

                      map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                      });
                    }
                  );
                })


                if (zoomCoredenate.length) {
                  map.flyTo({
                    center: zoomCoredenate,
                    zoom: 8
                  });
                }

                map.on('mousemove', 'unclustered-point', function (e) {

                  var coordinates = e.features[0].geometry.coordinates.slice();
                  var mag = e.features[0].properties.zippr;
                  var tsunami;

                  if (e.features[0].properties.tsunami === 1) {
                    tsunami = 'yes'
                  } else {
                    tsunami = 'no'
                  }

                  // Ensure that if the map is zoomed out such that
                  // multiple copies of the feature are visible, the
                  // popup appears over the copy being pointed to.
                  while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                  }

                  // new mapboxgl.Popup()
                  popup
                    .setLngLat(coordinates)
                    .setHTML("<b>" + mag + "</b>")
                    .addTo(map);
                });

                // map.on('mousemove', 'hourly-zipprs', function (e) {
                //   var description = e.features[0].properties.description;
                //   var coordinates = e.features[0].geometry.coordinates.slice();
                //   popup
                //     .setLngLat(e.lngLat)
                //     .setHTML("<b>" + e.features[0].properties.cluster_id + "</b>"
                //     )
                //     .addTo(map);
                // });
                map.on('mouseleave', 'unclustered-point', function () {
                  popup.remove()
                });

                // },1000);

              })
            }
          }
        }
      }
    })


    mapboxgl.accessToken = 'pk.eyJ1IjoidmVudWdvcGFhbCIsImEiOiJjazNmZml1bmYwM3FpM25vemh3cnlmOXR0In0.AdnqIyCvzVQYas34CcDwvg';



    // console.log(this.state.zoomTo,"th.state.zoomTo.");
    // let initialZoom;
    // if(this.state.zoomTo.length==2){
    //   initialZoom=this.state.zoomTo
    // }else{
    //   initialZoom=[79.7400, 15.907];
    // }



    map = new mapboxgl.Map({
      container: 'map',
      style:
        //{
        //   'version': 8,
        //   'sources': {
        //   'raster-tiles': {
        //   'type': 'raster',
        //   'tiles': [
        //     'https://4.aerial.maps.api.here.com/maptile/2.1/maptile/newest/satellite.day/{z}/{x}/{y}/256/png?app_id=P4UEExcJ2GCOynv1KNIb&app_code=hFRd8KXFK-iMhbgwzqmDXA'
        // ],
        //   'tileSize': 256,
        //   'attribution':
        //   'Map tiles by <a target="_top" rel="noopener" href="http://stamen.com">Stamen Design</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
        //   }
        //   },
        //   'layers': [
        //   {
        //   'id': 'simple-tiles',
        //   'type': 'raster',
        //   'source': 'raster-tiles',
        //   'minzoom': 0,
        //   'maxzoom': 22
        //   }
        // ]},
        'mapbox://styles/mapbox/streets-v11',
      // 'mapbox://styles/mapbox/dark-v10',

      center: [79.7400, 15.907],
      zoom: 5.5,

    });


  }

  refreshClick(e) {
    this.callMap();
    console.log("refresh clickedd")
  }

  callRealTimeData() {
    axios.get(this.state.selectedProject.recentActivity.url, {
      params: this.state.selectedProject.recentActivity.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let response = res.data.response.recentActivityObjects;
        let dataObjArray = [];
        response.map((element) => {
          let dataObj = {};
          dataObj.zippr = element.zippr;
          dataObj.thinUrl=`https://zip.pr/IN/${element.zippr}`;
          dataObj.agentName = element.agentName;
          dataObj.createdAt = element.createdAt;
          dataObjArray.push(dataObj);
        });
        this.setState({
          realtimeData: dataObjArray
        })
      })
  }

  callSnapShotData() {
    axios.get(this.state.selectedProject.snapShot.url, {
      params: this.state.selectedProject.snapShot.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        console.log(res,"resfgtyhhh")
        this.setState({
          snapShotData: res.data.response.result
        })
      })
  }




  agentSummeryFilteredDataCall(agentSummeryParams) {
    axios.get(this.state.selectedProject.agent_summary.url, {
      params: agentSummeryParams,
      headers: this.state.selectedProject.headers
    }).then(res => {
      let response = res.data.response.attendanceObjs;
      if (response) {
        this.setState({
          agentSummeryLoading: false
        })
      }
      let agentSummeryArray = [];
      response.map((record) => {
        let agentSummeryObject = {};
        agentSummeryObject.agencyName = record._id.agencyName;
        agentSummeryObject.today = record.today;
        agentSummeryObject.total = record.total;
        let percentage = (record.today / record.total) * 100;
        percentage = percentage.toFixed(2) + " %";
        agentSummeryObject.attendance = percentage;
        agentSummeryArray.push(agentSummeryObject);
      })
      this.setState({
        agentSummery: agentSummeryArray,
        work_order: work_order
      })
      // latest_work_order=work_order
    }).catch(err => { console.log(err, "err in agentsummmery") })
  }


  updateData(homeUlbDataParams) {

    if (latest_work_order) {
      workorder_param = latest_work_order
    } else {
      workorder_param = work_order
    }
    // if(workorder_param=='AP1'){
    //   this.state.selectedProject.agency_data.params.spaceKey=
    // }
    if(workOrder){
    this.state.selectedProject.agency_data.params.spaceKey = workOrder.hierarchy[workOrder.ulbLevel]
}
    this.state.selectedProject.agency_data.params.work_order = workorder_param;
    //homeUlbDataParams=this.state.selectedProject.agency_data.params;
    // homeUlbDataParams=params
    // let dwellingsHomeUlbDataParams=homeUlbDataParams;
    // dwellingsHomeUlbDataParams.zp_type=8
    // axios.get(this.state.selectedProject.agency_data.url, {
    //   params: dwellingsHomeUlbDataParams,
    //   headers: this.state.selectedProject.headers
    // })
    //   .then(res => {

    //   })

    axios.get(this.state.selectedProject.agency_data.url, {    //required
      params: homeUlbDataParams,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        console.log(res,"reddrr");
        if(res.data.ok){
        let response = res.data.response.analyticsDocs;
        if (response) {
          this.setState({
            ulbReportLoading: false
          })
        }

        let buildingsArray = [];
        let dwellingsArray = [];
        response.map(ele => {
          if (ele.zp_type == 7) {
            buildingsArray.push(ele)
          } else if (ele.zp_type == 8) {
            dwellingsArray.push(ele);
          }
        })
        let agencyDataObjectArray = [];
        buildingsArray.map(building => {
          if (dwellingsArray.length) {
            dwellingsArray.map(dwelling => {
              if (building.space.name == dwelling.space.name) {
                let agencyDataObject = {};
                agencyDataObject.portions = dwelling.count.ddn;
                agencyDataObject.agents = 0;
                agencyDataObject.ulb = building.space.name;
                agencyDataObject.buildings = building.count.ddn;
                agencyDataObjectArray.push(agencyDataObject);
              }
            })
          } else {
            buildingsArray.map(building => {
              let agencyDataObject = {};
              agencyDataObject.buildings = building.count.ddn;
              agencyDataObject.portions = 0;
              agencyDataObject.agents = 0;
              agencyDataObject.ulb = building.space.name;
              agencyDataObjectArray.push(agencyDataObject);
            })
          }
        })

        // let agencyDataObjectArray = [];
        // response.map((ele) => {
        //   let agencyDataObject = {};
        //   agencyDataObject.portions = ele.count.zp_type[8] ? ele.count.zp_type[8] : 0;
        //   agencyDataObject.agents = 0;
        //   // agencyDataObject.parcels = 0;
        //   agencyDataObject.ulb = ele.space.name; //
        //   agencyDataObject.buildings = ele.count.zp_type[7] ? ele.count.zp_type[7] : 0; //
        //   agencyDataObjectArray.push(agencyDataObject);

        // })
        let dwellingsAgencyDataObjectArray = [];
        // agencyDataObjectArray.map(ele=>{
        //   agencyDataObjectArray.map(innerEle=>{
        //   if(ele.ulb==innerEle.ulb){
        //     ele.portions=innerEle.portions;
        //     dwellingsAgencyDataObjectArray.push(ele);

        //   }
        //   })
        // })
        dwellingsAgencyDataObjectArray = _.uniqBy(agencyDataObjectArray, "ulb");

        this.setState({
          agencyDataObject: dwellingsAgencyDataObjectArray
        })
      }

      })



    // this.state.selectedProject.agent_summary.params.work_order = workorder_param
    // axios.get(this.state.selectedProject.agent_summary.url, {
    //   params: this.state.selectedProject.agent_summary.params,
    //   headers: this.state.selectedProject.headers
    // })
    //   .then(res => {
    //     let response = res.data.response.attendanceObjs;
    //     let agentSummeryArray = [];
    //     response.map((record) => {
    //       let agentSummeryObject = {};
    //       agentSummeryObject.agencyName = record._id.agencyName;
    //       agentSummeryObject.today = record.today;
    //       agentSummeryObject.total = record.total;
    //       let percentage = (record.today / record.total) * 100;
    //       percentage = percentage.toFixed(2) + " %";
    //       agentSummeryObject.attendance = percentage;
    //       agentSummeryArray.push(agentSummeryObject);
    //     })
    //     this.setState({
    //       agentSummery: agentSummeryArray,
    //       work_order: work_order
    //     })
    //     // latest_work_order=work_order
    //   })


    // axios.get(this.state.selectedProject.workOrderClients.url, {     //noneed in second time
    //   params: this.state.selectedProject.workOrderClients.params,
    //   headers: this.state.selectedProject.headers
    // })
    //   .then(res => {
    //     let workOrderClientsData = res.data.response.clientObjs;
    //     let clientObjectAyyay = [];
    //     workOrderClientsData.map((client) => {
    //       let clientObject = {
    //         name: client.app_name,
    //         id: client._id
    //       }
    //       clientObjectAyyay.push(clientObject);
    //     })
    //     this.setState({
    //       WorkOrderClients: clientObjectAyyay
    //     })


    //   })

  }

  ulbChange(e) {
    this.setState({
      ulbReportLoading: true
    })
    if (e.target.value == 'all') {
      homeUlbDataParams.spaceValue = "";
    } else {
      homeUlbDataParams.spaceValue = e.target.value;
    }
    this.updateData(homeUlbDataParams);
  }

  ulbTimeFilter(e) {
    this.setState({
      ulbReportLoading: true
    })
    homeUlbDataParams.timeKey = e.target.value;
    addDates(homeUlbDataParams);
    if (e.target.value == 'today' || e.target.value == 'this_month') {
      homeUlbDataParams.toDate = "";
    }
    this.updateData(homeUlbDataParams);
  }
  agencyFilter(e) {
    this.setState({
      ulbReportLoading: true
    })
    if (e.target.value == "all") {
      homeUlbDataParams.userKey = "allClients";
      homeUlbDataParams.clientId = ""
    } else {
      homeUlbDataParams.userKey = "client";
      homeUlbDataParams.clientId = e.target.value;
    }
    this.updateData(homeUlbDataParams);
  }

  agentSummeryTimeFilter(e) {
    agentSummeryParams.timeKey = e.target.value
    addDates(agentSummeryParams);
    if (e.target.value == 'today' || e.target.value == 'this_month') {
      agentSummeryParams.toDate = "";
    }

    let val = e.target.value;
    let value;
    if (val == 'today') {
      value = 'Today'
    } else if (val == 'yesterday') {
      value = 'Yesterday'
    } else if (val == 'last_7') {
      value = 'Last 7 Days'
    } else if (val == 'last_14') {
      value = 'Last 14 Days'
    } else if (val == 'this_month') {
      value = 'This Month'
    } else if (val == 'last_month') {
      value = 'Last Month'
    } else if (val == 'this_year') {
      value = 'This Year'
    } else if (val == 'lifetime') {
      value = 'Lifetime'
    }


    this.agentSummeryFilteredDataCall(agentSummeryParams);
    this.setState({
      agentSummeryBeginingDay: value,
      agentSummeryLoading: true
    })

  }


  downloadAgentSummeryData(e) {
    console.log('ccaaalllll');
    if(!this.state.agentSummeryAllCsv.length){
      this.clickAgentSummeryAllcsv();
    }

      this.setState({
        clickeddownloadAgencyDta: !this.state.clickeddownloadAgencyDta
      })



  }

  clickAgentSummeryVisiblecsv(e){
    let data = this.state.agentSummery;
    console.log(data,"dddaaattttaaa")
    this.setState({
      agentSummeryHeader: this.state.headers,
      agentSummeryData: data,
      clickeddownloadAgencyDta: !this.state.clickeddownloadAgencyDta
    })
  }

  clickAgentSummeryAllcsv(){
console.log(this.state.selectedProject.agent_summary.params,'clickAgentSummeryAllcsv90');
this.state.selectedProject.agent_summary.params.timeKey='lifetime';
    axios.get(this.state.selectedProject.agent_summary.url, {
      params: this.state.selectedProject.agent_summary.params,
      headers: this.state.selectedProject.headers
    }).then(res => {
      let response = res.data.response.attendanceObjs;
      if (response) {
        this.setState({
          agentSummeryLoading: false
        })
      }
      let agentSummeryArray = [];
      response.map((record) => {
        let agentSummeryObject = {};
        agentSummeryObject.agencyName = record._id.agencyName;
        agentSummeryObject.today = record.today;
        agentSummeryObject.total = record.total;
        let percentage = (record.today / record.total) * 100;
        percentage = percentage.toFixed(2) + " %";
        agentSummeryObject.attendance = percentage;
        agentSummeryArray.push(agentSummeryObject);
      })
      console.log(agentSummeryArray,"agentSummeryArrayvv");
      this.setState({
        agentSummeryAllCsv: agentSummeryArray,
        agentSummeryHeader: this.state.headers,
      })
      // latest_work_order=work_order
    }).catch(err => { console.log(err, "err in agentsummmery") })
  }

  downloadUlbData(){
    if(!this.state.ulbAllCsv.length){
      this.ulbDataDownloadAllCsv();
    }

    this.setState({
  clickeddownloadUlbData: !this.state.clickeddownloadUlbData
})
  }

  toggleUlbDownloadOptions(){
    this.setState({
      clickeddownloadUlbData: !this.state.clickeddownloadUlbData
    })
  }

  ulbDataDownloadAllCsv(e){

    if(allApis){
      console.log(allApis.agency_data,"allApis.agency_data000");
      if(workOrder){
        allApis.agency_data.params.spaceKey=workOrder.hierarchy[workOrder.ulbLevel];
      }
      axios.get(this.state.selectedProject.agency_data.url, {    //required
        params:allApis.agency_data.params ,
        headers: this.state.selectedProject.headers
      })
        .then(res => {
          let response = res.data.response.analyticsDocs;
          console.log(response,"responseulbdownload");
          if (response) {
            this.setState({
              ulbReportLoading: false
            })
          }

          let buildingsArray = [];
          let dwellingsArray = [];
          response.map(ele => {
            if (ele.zp_type == 7) {
              buildingsArray.push(ele)
            } else if (ele.zp_type == 8) {
              dwellingsArray.push(ele);
            }
          })
          let agencyDataObjectArray = [];
          buildingsArray.map(building => {
            if (dwellingsArray.length) {
              dwellingsArray.map(dwelling => {
                if (building.space.name == dwelling.space.name) {
                  let agencyDataObject = {};
                  agencyDataObject.portions = dwelling.count.ddn;
                  agencyDataObject.agents = 0;
                  agencyDataObject.ulb = building.space.name;
                  agencyDataObject.buildings = building.count.ddn;
                  agencyDataObjectArray.push(agencyDataObject);
                }
              })
            } else {
              buildingsArray.map(building => {
                let agencyDataObject = {};
                agencyDataObject.buildings = building.count.ddn;
                agencyDataObject.portions = 0;
                agencyDataObject.agents = 0;
                agencyDataObject.ulb = building.space.name;
                agencyDataObjectArray.push(agencyDataObject);
              })
            }
          })
          let dwellingsAgencyDataObjectArray = [];
          dwellingsAgencyDataObjectArray = _.uniqBy(agencyDataObjectArray, "ulb");
          console.log(dwellingsAgencyDataObjectArray,"dwellingsAgencyDataObjectArray")

          this.setState({
            ulbAllCsv: dwellingsAgencyDataObjectArray
          })

        })
    }

  }



  render() {

    console.log(this.state.agentSummery, "this.state.agentSummeryArray00")
    const csvData = [
      ["firstname", "lastname", "email"],
      ["Ahmed", "Tomi", "ah@smthing.co.com"],
      ["Raed", "Labes", "rl@smthing.co.com"],
      ["Yezzi", "Min l3b", "ymin@cocococo.com"]
    ];


    workOrder = localStorage.getItem("workOrderObj");
    workOrder = JSON.parse(workOrder);
    if(workOrder){
      work_order = workOrder.workOrder;
    }

    // if (this.state.work_order !== work_order) {
    //   latest_work_order = work_order;
    //   this.updateData(homeUlbDataParams)
    // }

    let data = [{
      ulb: "venu",
      parcels: "zippr",
      buildings: "ulb",
      portions: 1,
      agents: 10

    }]

    let { data: chartData } = this.state;


    let columns2 = [{ name: "ulb", title: "Ulb" },
    // { name: "parcels", title: "Parcels" },
    { name: "buildings", title: "Buildings" },
    { name: "portions", title: "Portions" },
      // { name: "agents", title: "Agents" }
    ];

    let columns = [{ name: "agencyName", title: "AgencyName" },
    { name: "today", title: "Today Agents" },
    { name: "total", title: "Total Agents" },
    { name: "attendance", title: "%Attendance" }]
    let todayTitle = toTitleCase(this.state.agentSummeryBeginingDay);
    columns[1].title = todayTitle + " Agents";


    let getHiddenColumnsFilteringExtensions = hiddenColumnNames => hiddenColumnNames
      .map(columnName => ({
        columnName,
        predicate: () => false,
      }));
    let defaultHiddenColumnNames = [];
    let filteringColumnExtensions = getHiddenColumnsFilteringExtensions(defaultHiddenColumnNames);
    let setFilteringColumnExtensions = getHiddenColumnsFilteringExtensions(defaultHiddenColumnNames);
    let onHiddenColumnNamesChange = hiddenColumnNames =>
      getHiddenColumnsFilteringExtensions(hiddenColumnNames);

    const result = chartData.map(({ splineValue, ...rest }) => ({ ...rest }));
    chartData = result;

    return (
      <div className='container-fluid'>

        <div className='row home-first-row'>
          <div className='col-md-6'>
            <div className='card home-card'>
              <div className='col-md-12' id='heading-timeline-home'>SNAPSHOT</div>
              <div className='row'>
                <div className='col-sm-6'>

                  <table class="table home-snapshot-table">
                    <thead>
                      <tr className='head-row4'>
                        <th scope="col" id='th-head'><i class="fa fa-users fa-2x" ></i></th>
                        <th scope="col" colspan='2' id='th-head'>Agents</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>today</td>
                        <td>Daily Avg</td>
                        <td>Total</td>
                      </tr>
                      {this.state.snapShotData ?
                        <tr className='secondRow-home'>
                          <td>{this.state.snapShotData ? this.state.snapShotData.agents.today : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.agents.average.toFixed(2) : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.agents.total : ""}</td>
                        </tr>
                        :
                        <img className='loader' src=
                          {loader}
                        />}
                    </tbody>
                  </table>

                  {/* <table class="table home-snapshot-table">
                    <thead>
                      <tr className='head-row'>
                        <th scope="col" id='th-head'><i class="fa fa-cube fa-2x" ></i></th>
                        <th scope="col" colspan='2' id='th-head'>Parcels</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>today</td>
                        <td>Daily Avg</td>
                        <td>Total</td>
                      </tr>
                      <tr className='secondRow-home'>
                        <td>0</td>
                        <td>184347</td>
                        <td>3.6M</td>
                      </tr>
                    </tbody>
                  </table> */}

                </div>
                <div className='col-sm-6'>
                  <table class="table home-snapshot-table">
                    <thead>
                      <tr className='head-row2'>
                        <th scope="col" id='th-head'><i class="fa fa-home fa-2x" ></i></th>
                        <th scope="col" colspan='2' id='th-head'>Buildings</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td>today</td>
                        <td>Daily Avg</td>
                        <td>Total</td>
                      </tr>
                      {this.state.snapShotData ?
                        <tr className='secondRow-home'>
                          <td>{this.state.snapShotData ? this.state.snapShotData.buildings.today : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.buildings.average.toFixed(2) : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.buildings.total : ""}</td>
                        </tr>
                        :
                        <img className='loader' src=
                          {loader}
                        />}

                    </tbody>
                  </table>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-6'>

                  <table class="table home-snapshot-table">
                    <thead>
                      <tr className='head-row3'>
                        <th scope="col" id='th-head'><i class="fa fa-building fa-2x" ></i></th>
                        <th scope="col" colspan='2' id='th-head'>Portions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td>today</td>
                        <td>Daily Avg</td>
                        <td>Total</td>
                      </tr>
                      {this.state.snapShotData ?
                        <tr className='secondRow-home'>
                          <td>{this.state.snapShotData ? this.state.snapShotData.dwellings.today : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.dwellings.average.toFixed(2) : ""}</td>
                          <td>{this.state.snapShotData ? this.state.snapShotData.dwellings.total : ""}</td>
                        </tr>
                        :
                        <img className='loader' src=
                          {loader}
                        />}

                    </tbody>
                  </table>
                </div>
                <div className='col-sm-6'>
                  {/* <table class="table home-snapshot-table">
                    <thead>
                      <tr className='head-row4'>
                        <th scope="col" id='th-head'><i class="fa fa-users fa-2x" ></i></th>
                        <th scope="col" colspan='2' id='th-head'>Agents</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td>today</td>
                        <td>Daily Avg</td>
                        <td>Total</td>
                      </tr>
                      <tr className='secondRow-home'>

                      <td>{this.state.snapShotData ? this.state.snapShotData.agents.today : ""}</td>
                        <td>{this.state.snapShotData ? this.state.snapShotData.agents.average : ""}</td>
                        <td>{this.state.snapShotData ? this.state.snapShotData.agents.total : ""}</td>
                      </tr>

                    </tbody>
                  </table> */}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'>

            <div className="card">
              <div className='col-md-12' id='heading-timeline'>MAP VIEW  <a className='home-maprefresh' onClick={this.refreshClick}><span className="glyphicon glyphicon-repeat" ></span><span> Refresh</span></a> </div>
              <div className='container-map'>
                <div className='card' id='map' style={{ width: "100%", height: "28.9em" }}></div>
              </div>




            </div>

          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>

            <div className="card">

{this.state.clickeddownloadAgencyDta ?
              <div className='agentsummery-downloadoptions'>
                <div class="list-group">
                <CSVLink
                data={this.state.agentSummeryAllCsv}
                 headers={this.state.agentSummeryHeader}
                 filename='dashboard_zipprs.csv'

                 >
                  <a  class="list-group-item list-group-item-action" onClick={this.downloadAgentSummeryData}>Export all data as csv</a>
                  </CSVLink>
                 <CSVLink
                  // data={this.state.agentSummeryData}
                  data={this.state.agentSummery}
                  headers={this.state.agentSummeryHeader}
                  filename='dashboard_zipprs.csv'>
                  <a  class="list-group-item list-group-item-action" onClick={this.clickAgentSummeryVisiblecsv.bind(this)}>Export visible data as csv</a>
                  </CSVLink>

                </div>
              </div>
              :
              ""
              }

              <div className='col-md-12' id='heading-timeline'>AGENT SUMMARY</div>
              <br />
              <div className='row' id='select-row'>
                <div className='col-md-3 firsr-select' >
                  <select class="form-control" id="sel1" onChange={this.agentSummeryTimeFilter.bind(this)}>
                    <option value='today'>Today</option>
                    <option value='yesterday'>Yesterday</option>
                    <option value='last_7'>Last 7Days</option>
                    <option value='last_14'>last 14Days</option>
                    <option value='this_month'>This Month</option>
                    <option value='last_month'>Last Month</option>
                    <option value='this_year'>This Year</option>
                    <option value='lifetime'>Life Time</option>
                  </select>
                </div>
                <div className='col-md-3'>

                </div>
                <div className='col-md-3'>

                </div>
                <div className='col-md-3 last-part'>
                  {/* <CSVLink className='download-csv' data={this.state.agentSummeryData} headers={this.state.agentSummeryHeader}> */}

                    <button className='download-button' onClick={this.downloadAgentSummeryData}>
                      <svg className="bi bi-arrow-down-short" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 7.646a.5.5 0 01.708 0L8 10.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z" clip-rule="evenodd" />
                        <path fill-rule="evenodd" d="M8 4.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  {/* </CSVLink> */}
                </div>



              </div>
              {this.state.agentSummeryLoading ?
                <img className='loader' src=
                  {loader}
                />
                :

                <Grid
                  rows={this.state.agentSummery}
                  columns={columns}
                >

                  <FilteringState defaultFilters={[]} />
                  <IntegratedFiltering />
                  <SortingState
                    defaultSorting={[{ columnName: 'city', direction: 'asc' }]}
                  />
                  <IntegratedSorting />

                  {/* <SearchState defaultValue="" />
        <IntegratedFiltering
          columnExtensions={filteringColumnExtensions}
        /> */}
                  <VirtualTable
                    height="20em"
                  />
                  <TableHeaderRow showSortingControls />
                  <TableFilterRow />
                  <TableColumnVisibility
                    defaultHiddenColumnNames={defaultHiddenColumnNames}
                    onHiddenColumnNamesChange={onHiddenColumnNamesChange}
                  />
                  <Toolbar />
                  {/* <SearchPanel /> */}
                  <ColumnChooser />

                </Grid>
              }
            </div>

          </div>
          <div className='col-md-6'>


            <div className="card ">

            {this.state.clickeddownloadUlbData ?
              <div className='agentsummery-downloadoptions'>
                <div class="list-group">
                <CSVLink
                data={this.state.ulbAllCsv}
                 headers={this.state.ulbHeader}
                 filename='dashboard_zipprs.csv'

                 >
                  <a  class="list-group-item list-group-item-action" onClick={this.toggleUlbDownloadOptions}>Export all data as csv</a>
                  </CSVLink>
                 <CSVLink data={this.state.agencyDataObject} headers={this.state.ulbHeader} filename='dashboard_zipprs.csv'>
                  <a  class="list-group-item list-group-item-action" onClick={this.toggleUlbDownloadOptions}>Export visible data as csv</a>
                  </CSVLink>

                </div>
              </div>
              :
              ""
              }

              <div className='col-md-12' id='heading-timeline'>ULB Report</div>
              <br />
              <div className='row' id='select-row'>
                <div className='col-md-3 firsr-select' >
                  <select class="form-control" id="sel1" onChange={this.agencyFilter.bind(this)}>
                    <option value="all">All Agencies</option>
                    {this.state.WorkOrderClients ? this.state.WorkOrderClients.map((client) => {
                      return <option value={client.id}>{client.name}</option>
                    })
                      : ""}
                  </select>
                </div>
                <div className='col-md-3'>
                  <select class="form-control" id="sel1" onChange={this.ulbChange.bind(this)}>
                    <option value="all">All Ulbs</option>
                    {this.state.ulbNameArray ? this.state.ulbNameArray.map((ulb) => {
                      return <option value={ulb.spaceValue}>{ulb.name ? ulb.name : ""}</option>
                    })
                      : ""}
                  </select>
                </div>
                <div className='col-md-3'>
                  <select class="form-control" id="sel1" onChange={this.ulbTimeFilter.bind(this)}>
                    <option value='today'>Today</option>
                    <option value='yesterday'>Yesterday</option>
                    <option value='last_7'>Last 7Days</option>
                    <option value='last_14'>last 14Days</option>
                    <option value='this_month'>This Month</option>
                    <option value='last_month'>Last Month</option>
                    <option value='this_year'>This Year</option>
                    <option value='lifetime'>Life Time</option>
                  </select>
                </div>
                <div className='col-md-3 last-part'>
                <button className='download-button' onClick={this.downloadUlbData}>
                      <svg className="bi bi-arrow-down-short" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 7.646a.5.5 0 01.708 0L8 10.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z" clip-rule="evenodd" />
                        <path fill-rule="evenodd" d="M8 4.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5z" clip-rule="evenodd" />
                      </svg>
                    </button>
                </div>
              </div>
              {this.state.ulbReportLoading ? <img className='loader' src={loader} /> :
                <Grid
                  rows={this.state.agencyDataObject}
                  columns={columns2}
                >

                  <FilteringState defaultFilters={[]} />
                  <IntegratedFiltering />


                  <SortingState
                    defaultSorting={[{ columnName: 'city', direction: 'asc' }]}
                  />
                  <IntegratedSorting />

                  {/* <SearchState defaultValue="" />
        <IntegratedFiltering
          columnExtensions={filteringColumnExtensions}
        /> */}
                  <VirtualTable
                    height="20em"
                  />
                  <TableHeaderRow showSortingControls />
                  <TableFilterRow />
                  <TableColumnVisibility
                    defaultHiddenColumnNames={defaultHiddenColumnNames}
                    onHiddenColumnNamesChange={onHiddenColumnNamesChange}
                  />
                  <Toolbar />
                  {/* <SearchPanel /> */}
                  <ColumnChooser />

                </Grid>
              }
            </div>

          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            <div className="card realtime-card">
              <div className='col-md-12' id='heading-timeline'>REAL-TIME ACTIVITY</div>
              <div className='realtimeActivity'>
                {this.state.realtimeData.map((element) => {
                  return <><span> <a href={element.thinUrl} target="_blank"><u>{element.zippr}</u></a><span> created By </span><a href="#">{element.agentName}</a><span> (</span><span> {moment(element.createdAt).fromNow()}</span><span>)</span></span> <br /></>
                })
                }
              </div>
            </div>

          </div>
          <div className='col-md-6'>
            {/* <div className="card timeline-card">
              <div className='col-md-12' id='heading-timeline'>TIMELINE</div>

              <div className='row' id='select-row-timeline'>
                <div className='col-md-3 firsr-select' >
                  <select class="form-control" id="sel1">
                    <option>All Agencies</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div className='col-md-3'>
                  <select class="form-control" id="sel1">
                    <option>All Ulbs</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div className='col-md-3'>
                  <select class="form-control" id="sel1">
                    <option>Last 7Days</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div className='col-md-3'></div>
              </div>
              <div className='timeline-container'>
                <Paper>
                  <Chart
                    data={[{
                      lineValue: 100,
                      argument: "jan"
                    }, {
                      lineValue: 200,
                      argument: "feb"
                    },
                    {
                      lineValue: 150,
                      argument: "march"
                    }]}
                  >
                    <ArgumentAxis />
                    <ValueAxis />

                    <LineSeries
                      name="line"
                      valueField="lineValue"
                      argumentField="argument"
                    />

                    <EventTracker />
                    <Tooltip target={{ clientHeight: 10, clientWidth: 10 }} />
                  </Chart>
                </Paper>
              </div>
            </div> */}
          </div>
        </div>

      </div>
    )
  }
}
